
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>William reist nach Belgien</h4>
    <p>
  Der befristete Platz im Wohnheim in Olten ist abgelaufen. William W. darf nun alleine wohnen, in einem eigenen
  Mansardenzimmer in Zofingen AG. Obwohl der «geschützte Wohnrahmen» eine zentrale Voraussetzung war für seine
  Entlassung. Die Bewährungshilfe begründet den Schritt damit, dass man trotz intensiver Suche keine neue Unterkunft
  gefunden habe.
    </p>
    <p>
  Der 44-Jährige lässt in der Folge etliche Alkoholtests aus. Er schwänzt eine Sitzung mit dem Therapeuten. Die
  Übertragung der Fussfessel ist erneut unterbrochen. Und das Solothurner Amt für Justizvollzug? Es spricht zwei weitere
  Ermahnungen aus.
    </p>
    <p>
  William W. stellt nun ein Gesuch, um das GPS-Gerät für vier Tage entfernen zu dürfen. So könne er nach Brüssel,
  zusammen mit der evangelische Kirchgemeinde Olten, die dort einen christlichen Kongress besucht. Das Amt für
  Justizvollzug lehnt das Gesuch ab, später auch das Verwaltungsgericht. W. hat dort deutlich gemacht, was er von der
  Überwachung hält: Sie sei «vollkommen ungeeignet, um Straftaten zu verhindern».
    </p>
    <p>
  Das Solothurner Innendepartement entscheidet schliesslich am 22. November 2017, die Reise nach Belgien nicht zu
  ermöglichen. Das öffentliche Interesse an einer engmaschigen Überwachung sei gewichtiger. Doch das kümmert den
  44-Jährigen nicht, wie sich schon am Tag darauf zeigt: «Am 23. November informierte die Bewährungshilfe, William W.
  sei gleichentags aus der Schweiz ausgereist», steht im Untersuchungsbericht. Um 17.42 Uhr geht das letzte Signal des
  GPS-Trackers ein ‒ aus Belgien. Kurz danach schaltet sich das Gerät aus. Der Wiederholungstäter verschwindet vom
  Radar.
  <Image source='Eine solche Fussfessel mit separatem GPS-Gerät sollte W. tragen.' file={require('images/fussfessel.png')} style={{
        maxWidth: '50%'
      }} mdxType="Image" />
    </p>
    <p>
  Vier Tage vergehen. Dann meldet er sich bei der Bewährungshilfe. Was er in Belgien unternommen hat, ist im
  Untersuchungsbericht nicht aufgeführt. Dafür seine Begründung, warum die Überwachung während Tagen nicht
  funktionierte: «Bei der Übernachtung in einem Doppelbett sei er mit der Fussfessel hängen geblieben und diese sei
  abgerissen.» Die Behörden bringen das Gerät wieder an. Sie ermahnen W. «zum wiederholten Mal». Konsequenzen bleiben
  offenbar aus.
    </p>
    <p>
  Der Therapeut scheint trotz allem zufrieden. Nur einen Monat später berichtet er, der 44-Jährige verhalte sich
  kooperativ, zuverlässig. Der Behandlungsverlauf sei positiv. Ein Tag nach dieser Beurteilung ermahnt die
  Vollzugsbehörde W. schon wieder. «Weil es erneut zu Unterbrüchen der GPS-Überwachung gekommen war», steht im
  Untersuchungsbericht.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;